// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"36a4f496","81":"59c84176"}[chunkId] + ".chunk.js";
};